'use client'

import {
    BaseInputLabel,
    BaseInputStyled,
    BaseInputWrapper
} from "@/components/UI/Form/Inputs/BaseInput/BaseInput.styled";
import {Field} from "formik";
import ErrorMessage from "@/components/UI/Form/ErrorMessage/ErrorMessage";

const BaseInput = ({label, name, inputProps, error, onFieldChange, onChange, hideError = false, ...props}) => {
    return (
        <BaseInputWrapper {...props}>
            <Field name={name ?? label}>
                {
                    (formikField) => {
                        const {field, meta} = formikField;

                        return <>
                            {label && <BaseInputLabel>{label}</BaseInputLabel>}
                            <BaseInputStyled
                                {...field}
                                {...inputProps}
                                placeholder={inputProps?.placeholder || label}
                                onChange={(e) => {
                                    onFieldChange ? onFieldChange(e, formikField) : field.onChange(e)
                                    inputProps?.onChange?.(e)
                                    onChange?.(e.target.value)
                                }}
                            />
                            {!hideError && <ErrorMessage meta={meta} error={error} />}
                        </>
                    }
                }
            </Field>
        </BaseInputWrapper>
    );
};

export default BaseInput;